import { RootState } from '..';

export const selectFilterState = (state: RootState) =>
  state.filterConsumerUnit.filterState;

export const selectFilterUtilityCompanyId = (state: RootState) =>
  state.filterConsumerUnit.utilityCompanyId;

export const selectFilterPeriod = (state: RootState) =>
  state.filterConsumerUnit.period;

export const selectFilterMonthSelected = (state: RootState) =>
  state.filterConsumerUnit.monthSelected;

export const selectFilterStartDate = (state: RootState) =>
  state.filterConsumerUnit.startDate;

export const selectFilterEndDate = (state: RootState) =>
  state.filterConsumerUnit.endDate;
